const slugify = require("slugify");

const createSlug = text =>
  slugify(text, {
    lower: true,
    remove: /[$*+~.()=#'"!:@?,&\/]/g
  });

module.exports = createSlug;
